import { Icon } from '@iconify/react'
import { Tooltip } from '@pepper/ui'

import s from './PotentialTrafficTooltipIcon.module.css'

export const PotentialTrafficTooltipIcon = () => {
  const url =
    'https://www.notion.so/pepperc/Potential-Traffic-The-What-Why-How-0fc0ec16e6334a559fc01e51835f4554'
  return (
    <Tooltip
      title={
        <>
          <p>The potential monthly organic traffic for corresponding topic.</p>
          Note that this is an estimate and might not be conclusive.
          <a
            href={url}
            target="_blank"
            className={s.trafficLink}
            rel="noreferrer"
          >
            Learn how we calculate this.
          </a>
        </>
      }
      placement="bottom"
    >
      <Icon icon="lucide:test-tube-2" />
    </Tooltip>
  )
}
